import { NgModule } from "@angular/core";
import { CommonComponentsModule } from "src/app/common-components";
import { WawiApiBelegCreateFormComponent } from "./create/form/form.component";
import { WawiApiBelegCreateDialogComponent } from "./create/dialog/dialog.component";
import { WawiApiBelegSelectDialogComponent } from "./select/dialog/beleg-select-dialog.component";
import { CstResponsivePopupModule } from "src/app/common-components/resp-popup/resp-popup.module";
import { CstListViewModule } from '../../common-components/list-view/list-view.module';
@NgModule({
  imports: [
    CommonComponentsModule,
    CstResponsivePopupModule,
    CstListViewModule
  ],
  declarations: [
    WawiApiBelegCreateFormComponent,
    WawiApiBelegCreateDialogComponent,
    WawiApiBelegSelectDialogComponent,
  ],
  exports: [
    WawiApiBelegCreateFormComponent,
    WawiApiBelegCreateDialogComponent,
    WawiApiBelegSelectDialogComponent,
  ],
})
export class WawiApiBelegeModule { }
